"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _TimezoneGroups = _interopRequireDefault(require("../lists/TimezoneGroups"));

var _TimezoneBlacklist = _interopRequireDefault(require("../lists/TimezoneBlacklist"));

var _TimezoneGroup = _interopRequireDefault(require("../records/TimezoneGroup"));

var _Timezone = _interopRequireDefault(require("../records/Timezone"));

var MAX_CITIES_IN_GROUP_NAME = 4;

var _default = function _default(timezoneAliases) {
  var currentMoment = _I18n.default.moment().valueOf();

  var timezonesByZoneRegion = _I18n.default.moment.tz.names().filter(function (name) {
    return name.search(/GMT/g) < 0 && name.search(/Etc/g) < 0 && name.search(/\//g) > -1 && !_TimezoneBlacklist.default.includes(name);
  }).reduce(function (byZoneRegion, name) {
    var zoneRegion = name.split('/')[0];
    if (!byZoneRegion[zoneRegion]) byZoneRegion[zoneRegion] = [];
    byZoneRegion[zoneRegion].push(name);
    return byZoneRegion;
  }, {});

  var timezoneGroups = Object.keys(timezonesByZoneRegion).map(function (zoneRegion) {
    var timezonesForZoneRegion = timezonesByZoneRegion[zoneRegion];
    var sortedTimezones = timezonesForZoneRegion.reduce(function (byMatchingZoneType, timezoneName) {
      var momentTimezone = _I18n.default.moment.tz.zone(timezoneName);

      var futureUntils = momentTimezone.untils.filter(function (until) {
        return until > currentMoment;
      });
      var futureOffsets = momentTimezone.offsets.slice(-futureUntils.length);
      var key = futureUntils.concat(futureOffsets).join('');
      if (!byMatchingZoneType[key]) byMatchingZoneType[key] = [];
      byMatchingZoneType[key].push(timezoneName);
      return byMatchingZoneType;
    }, {});
    var timezones = Object.values(sortedTimezones).map(function (momentTimezones) {
      var aliasWithTimezoneInGroup = function aliasWithTimezoneInGroup(alias) {
        return alias.timezones.some(function (timezone) {
          return momentTimezones.indexOf(timezone) !== -1;
        });
      };

      var alias = timezoneAliases.find(aliasWithTimezoneInGroup);

      var offset = _I18n.default.moment.tz(momentTimezones[0]).format('Z');

      if (alias) {
        return new _Timezone.default({
          offset: offset,
          momentTimezones: (0, _immutable.List)(momentTimezones),
          name: alias.name
        });
      }

      var cityNames = momentTimezones.map(function (timezone) {
        return timezone.split('/').pop().toLowerCase();
      });
      var translatedCityNames = cityNames.map(function (name) {
        return _I18n.default.text("timezone_utils.cities." + name);
      });

      var name = _I18n.default.formatList(translatedCityNames.slice(0, MAX_CITIES_IN_GROUP_NAME));

      return new _Timezone.default({
        offset: offset,
        momentTimezones: (0, _immutable.List)(momentTimezones),
        name: name
      });
    });
    return new _TimezoneGroup.default({
      groupName: _I18n.default.text("timezone_utils.regions." + zoneRegion.toLowerCase()),
      timezones: (0, _immutable.List)(timezones)
    });
  });
  return new _TimezoneGroups.default(timezoneGroups);
};

exports.default = _default;
module.exports = exports.default;